export const STATUS_PUBLICACAO = {
    
    RASCUNHO: "RASCUNHO",
    PRONTO_PARA_PUBLICAR: "PRONTO_PARA_PUBLICAR",
    PUBLICADO: "PUBLICADO"
}